<script>
import CrmAccountsAccountNotes from '@/views/Application/CustomerService/Accounts/Account/Notes'

export default {
  extends: CrmAccountsAccountNotes,
  data () {
    return {
      breadcrumb: {
        name: 'All Notes',
        route: { name: 'sales-opportunities-account-notes', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
